import {accountTypes} from '@bdswiss/common-enums'

/**
 * Default the dashboard signup product to the live MT5 SVG account for SVG/TauroMarkets
 * when no explicit account type was requested.
 *
 * SVG/TauroMarkets live registrations create an MT5 account on the backend
 * (swapDefaultSvgSignupProductToMt5, see PT-5522), but the form otherwise resolves its
 * default to the live MT4 Classic product. This keeps the signup request consistent with
 * what actually gets created. Explicit-type URLs (e.g. /register/forex_classic) are left
 * untouched on purpose — the backend swap remains the safety net that covers them.
 *
 * @param resolvedProduct - product name the form resolved for the signup request
 * @param hasExplicitType - whether the registration URL specified an account type
 * @returns the product name to submit
 */
export const resolveDefaultSignupProduct = (
  resolvedProduct: string,
  hasExplicitType: boolean,
): string =>
  !hasExplicitType &&
  resolvedProduct === accountTypes.ForexClassicTauroMarketsAccount.productName
    ? accountTypes.ForexMT5SVGTauromarketsAccount.productName
    : resolvedProduct
